function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icecream");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("ellipse", {
  id: "Oval-3",
  fill: "#F0F0F0",
  cx: 79.2,
  cy: 253.2,
  rx: 57.6,
  ry: 4.8
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  id: "Rectangle-8",
  fill: "#F2D1A0",
  x: 57,
  y: 194.4,
  width: 45,
  height: 61.2,
  rx: 22.5
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M79.2,-9.09494702e-13 C121.735466,-9.09494702e-13 156.439231,33.5342993 158.319772,75.6001208 L0.0802069596,75.5997717 C1.94092031,33.9626972 35.9450872,0.690509931 77.8900004,0.0106100866 L79.2,-9.09494702e-13 Z",
  id: "Combined-Shape",
  fill: "#FF5959"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  id: "Rectangle-6",
  fill: "#FFF3F3",
  x: 0,
  y: 75.6,
  width: 158.4,
  height: 69.6
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  id: "Rectangle-6",
  fill: "#72B7FF",
  x: 0,
  y: 145.2,
  width: 158.4,
  height: 69.6
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M101.84262,15.0979644 C117.44344,20.3601987 130.610712,30.910253 139.212491,44.6157545 M144.2639,54.2354968 C145.598107,57.3356029 146.717197,60.5500621 147.602374,63.860077",
  id: "Mask",
  stroke: "#FFFFFF",
  strokeWidth: 5.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.6,2.4 C95.5950716,2.4 97.5718022,2.47853181 99.5272696,2.63267182 C133.418546,11.6071293 158.4,42.4877865 158.4,79.1966363 L158.402104,155.984958 C145.819125,178.227981 122.112951,193.347821 94.8306057,193.790033 L93.6,193.8 C52.5100146,193.8 19.2,160.488006 19.2,119.405912 L19.2,76.7940883 C19.2,36.1182351 51.8382906,3.06692529 92.3693943,2.40996668 L93.6,2.4 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF",
  opacity: 0.24718657
});

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group-3",
  transform: "translate(48.000000, 174.000000)",
  fill: "#285A75"
}, React.createElement("circle", {
  id: "Oval-2",
  cx: 5.4,
  cy: 5.4,
  r: 5.4
}), React.createElement("circle", {
  id: "Oval-2",
  cx: 57.6,
  cy: 5.4,
  r: 5.4
}));

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69,185.4 C69,191.033304 73.5666956,195.6 79.2,195.6 L79.2,195.6 C84.8333044,195.6 89.4,191.033304 89.4,185.4",
  id: "Oval-2",
  fill: "#285A75"
});

var SvgIcecream = function SvgIcecream(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "159px",
    height: "258px",
    viewBox: "0 0 159 258",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Artboard",
    transform: "translate(-908.000000, -158.000000)"
  }, React.createElement("g", {
    id: "icecream",
    transform: "translate(908.000000, 158.000000)"
  }, _ref4, _ref5, React.createElement("g", {
    id: "Group-2"
  }, _ref6, _ref7, _ref8, React.createElement("g", {
    id: "Group",
    transform: "translate(36.600000, 49.800000)",
    fill: "#000000",
    fillOpacity: 0.05
  }, React.createElement("rect", {
    id: "Rectangle-7",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0,
    y: 0,
    width: 33.6,
    height: 121.8,
    rx: 16.8
  }), React.createElement("rect", {
    id: "Rectangle-7",
    style: {
      mixBlendMode: "multiply"
    },
    x: 51.6,
    y: 0,
    width: 33.6,
    height: 121.8,
    rx: 16.8
  })), _ref9, _ref10), React.createElement("rect", {
    id: "Rectangle-9",
    fillOpacity: 0.1,
    fill: "#000000",
    style: {
      mixBlendMode: "multiply"
    },
    x: 57,
    y: 214.8,
    width: 45,
    height: 5.4
  }), _ref11, _ref12))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcecream, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icecream.cef45330.svg";
export { ForwardRef as ReactComponent };